/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Shortcuts_ActionInputs */

const en_pc_tut_shortcuts_action = /** @type {(inputs: Pc_Tut_Shortcuts_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const zh_pc_tut_shortcuts_action = /** @type {(inputs: Pc_Tut_Shortcuts_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Pc_Tut_Shortcuts_ActionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_shortcuts_action = /** @type {((inputs?: Pc_Tut_Shortcuts_ActionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Shortcuts_ActionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_shortcuts_action(inputs)
	return zh_pc_tut_shortcuts_action(inputs)
});
export { pc_tut_shortcuts_action as "pc.tut.shortcuts.action" }